export enum SERVICE_STATUS {
  APPLICATION = "00",
  ACTIVATE = "01",
  CEASE = "08",
  DEACTIVATE = "08",
  DELETE = "09"
}

export enum SCHEDULE {
  ALL = "",
  IMMEDIATE = "0001",
  SCHEDULE = "0002",
}

// Approval status type
export enum APPROVAL_STATUS {
  ALL = "",
  REQUESTED = "00",
  APPROVED = "01",
  PROCESSING = "02",
  RESUMITTED = "03",
  NEEDSMYAPPROVAL = "04",
  WAITING = "05",
  REJECTED = "08",
  FAILED = "91",
  CANCELED = "CC",
}

export enum CHANNEL {
  CIB = "01", // Coporate Internet Banking channel
  MOB = '03', // Mobile Banking channel
}

export enum TRANSACTION_STATUS {
  PROCESSING = "001",
  FAILED = "002",
  COMPLETED = "003",
  UNKNOWN = "000",
}

export enum BANK_GROUP {
  CODE = "01",
  NAME = "02",
}

export enum BANK {
  OURS = "000",
}

export enum CURRENCY {
  KHR = "0097",
  USD = "0072",
}
export enum CURRENCY_CODE {
  KHR = "KHR",
  USD = "USD",
}

export enum USER {
  ALL_ACCOUNT = "01",
  DESIGNATED_ACCOUNT = "02",
}

export enum LANGUAGE {
  en = "01",
  km = "02",
  zh = "05",
  // add new
  EN = '01',      // english
  KM = '02',      // khmer
  KO = '03',      // korean
  JA = '04',      // japanese
  ZH = '05',      // chines
  I18N_EN = 'en',
  I18N_KM = 'km',
  I18N_KO = 'ko',
  I18N_JA = 'ja',
  I18N_ZH = 'zh'
}

export enum MENU_PATH {
  HOM1000 = "/main/home",
  PUS1000 = "/main/push",
  REG1000 = "/register",
  LOG1000 = "/login",
  UMG1000 = "/main/user-management",
  MCI1000 = "/main/merchant-inquiry",
  MCI1100 = "/main/merchant-inquiry/detail",
}

export enum MENU_CODE {
  home = "HOM1000",
  setting = "HOM3400",
  merchantinquiry = "MCI1000",
  merchantinquirydetail = "MCI1100",
}

export enum MENU_NAME {
  HOM1000 = "COMMON.LABEL.HOME",
  UMG1000 = "COMMON.LABEL.USER_MANAGEMENT",
  MCI1000 = "COMMON.LABEL.MERCHANT_INQUIRY",
  MCI1100 = "COMMON.LABEL.MERCHANT_INQUIRY_DETAIL",
}

export const PATH_CODE = {
  "/main/home": "HOM1000",
  "/main/user-management": "UMG1000",
  "/main/merchant-inquiry": "MCI1000",
  "/main/merchant-inquiry/detail": "MCI1100",
};

export enum DGB {
  MAIN = "https://www.dgbcambodia.com/",
  GENERAL_LAON = "https://www.dgbcambodia.com/general-loan/",
  HOUSING_LOAN = "https://www.dgbcambodia.com/housing-loan/",
  CAR_LOAN = "https://www.dgbcambodia.com/car-loan/",
  NOTICE = "https://www.dgbcambodia.com/workshops/",
  CONTACT = "https://www.dgbcambodia.com/contact-us/",
  CAREERS = "https://www.dgbcambodia.com/opportunities/",
  FACEBOOK = "https://www.facebook.com/DGB-Bank-1666082523605367",
}

export enum AES_INFO {
  STORE = "AES_INFO",
}

export enum USER_INFO {
  STORE = "USER_INFO",
}

export enum TRANSFER_TAB {
  DIRECT_INPUT = "direct_input",
  RECENT = "recent",
  FREQUENT = "frequent",
  MY_ACCOUNT = "my_account",
}

export const LOGO_FILE_EXT = [".jpg", ".png", ".jpeg", ".bmp"];

export const OVERSEAS_FILE_EXT = ["PDF", "DOC", "DOCX", "XLS", "XLSX", "PPT", "PPTX", "TIF", "TIFF", "JPG", "JPEG", "PNG", "GIF", "BMP", "RAW"];


export const MAX_FILE_UPLOAD_SIZE = 4194304;

export const HOUR_LIST = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];

export const MINUTE_LIST = [0, 10, 20, 30, 40, 50];

export enum LOCAL_STORAGE {
  AESIV                           = 'AESIV',
  ERROR_CODE                      = 'errorCode',
  IS_AVAILABLE_BIO_AUTHENTICATION = 'isAvailableBioAuthentication',
  IS_FIIST_LOGIN                  = 'isFirstLogin',
  BIO_AUTHENTICATION              = 'bioAuthentication',
  IS_NOT_SHOW_AGAIN               = 'doNotShowAgain',
  DEVICE_INFO                     = 'deviceInfo',
  CONTENTS_VERSION                = 'contentsVersion',
  PRE_TRANSACTION                 = 'preTransaction',
  USER_INFO                       = 'userInfo',
  IS_REMEMBER_ID                  = 'isRememberId',
  USER_ID                         = 'userID',
  GUESS_USER_ID                   = 'guessUserID',
  LANGUAGE_CODE                   = 'languageCode',
  I18N                            = 'i18n',
  LAST_EVENT_TIME                 = 'lastEventTime',
  LAST_TIME_CHECK_NOTIFICATION    = 'theLastTimeCheckNotification',
  IS_SKIP_GUIDE                   = 'isSkipGuide',
  IS_SKIP_GUIDE_BILL_PAYMENT      = 'isSkipGuideBillPayment',
  ALREADY_SHOW_GUIDE              = 'alreadyShowGuide',
  ALREADY_SHOW_GUIDE_BILL_PAYMENT = 'alreadyShowGuideBillPayment',
  ALREADY_SHOW_GUIDE_NOTICE       = 'alreadyShowGuideNotice',
  IS_SKIP_GUIDE_NOTICE            = 'isSkipGuideNotice',
  IS_FIRST_DISPLAY                = 'isFirstDisplay',
  IS_FIRST_DISPLAY_ONE            = 'isFirstDisplayOne',
  OTP_DATA                        = 'otp',
  IS_DONT_SHOW_AGAIN              = 'isDontShowAgain',
  IS_FIRST_APP_INSTALL            = 'isFirstAppInstall',
  IS_CREATE_CONTENTS_INTEGRITY    = 'isCreateContentsIntegrity',
  FINGERPRINT_POPUP_ACTIVITY      = 'fingerprintPopupActivity',
  BIO_AUTHENTICATION_USER_ID      = 'bioAuthenticationUserId',
  BIO_TYPE                        = 'bioAuthenticationType',
  LAST_EVENT_TIME_OF_DUMMY_LOGIN  = 'lastEventTimeOfDummyLogin',
  IS_PERMSSION_ALREADY_REQUESTED  = 'isPermissionAlreadyRequested'
}


export enum DateTimeFormat {
  // 'dd/MMM/yyyy HH:mm:ss'
  hhmm            = 'HH:mm' ,
  hhmmss          =  'HH:mm:ss',
  yyyymmdd        = 'yyyy.MM.dd', // Korean/Japan/china
  yyyymmddhhmm    = 'yyyy.MM.dd HH:mm',
  yyyymmddhhmmss  = 'yyyy.MM.dd HH:mm:ss',

  ddmmmyyyy        = 'dd/MMM/yyyy', // US
  ddmmmyyyyhhmm    = 'dd/MMM/yyyy HH:mm',
  ddmmmyyyyhhmmss  = 'dd/MMM/yyyy HH:mm:ss',

  ddmmyyyy        = 'dd/MM/yyyy', // Cambodia
  ddmmyyyyhhmm    = 'dd/MM/yyyy HH:mm',
  ddmmyyyyhhmmss  = 'dd/MM/yyyy HH:mm:ss',
}

export enum PeriodDateOptionValue {
  ONE_WEEK    = 'tab_1w',
  ONE_MONTH   = 'tab_1m',
  THREE_MONTH = 'tab_3m',
  SIX_MONTH   = 'tab_6m'
}
